import { type Project } from '@littlebird/sdk';

export const getProjectSidebarIcon = (
  project: Project,
  isExpanded: boolean | undefined
) => {
  const usesDefaultFolderIcon =
    !project.icon ||
    (project.icon.type === 'icon' &&
      (!project.icon.code || project.icon.code === 'folder'));
  return usesDefaultFolderIcon && isExpanded
    ? {
        type: 'icon' as const,
        code: 'folder-open' as const,
        color: project.icon?.color ?? null,
      }
    : project.icon;
};
